import type { QueryClient } from "@tanstack/react-query";
import type { Chart } from "../domain/models/chart";
import type { IncarnationCross } from "../utils/calculations";
import type { SavedChartLibraryItem } from "./chart-library";

export interface ChartEditDraft {
  id?: string;
  claimInviteToken?: string;
  email: string;
  name: string;
  date: string;
  time: string;
  city: string;
  latitude?: number;
  longitude?: number;
  phoneNumber?: string;
  chartOwner: "self" | "other";
  operationalEmailConsent?: boolean;
  marketingEmailConsent?: boolean;
  emailConsentRecordedAt?: string;
}

export interface WizardQueryState {
  savedChartId?: string | null;
  sourceChart?: SavedChartLibraryItem | null;
  chart: Chart;
  incarnationCross: IncarnationCross;
  reportOutput: string;
  isOwnerChart: boolean;
}

export const appQueryKeys = {
  wizard: () => ["app", "wizard"] as const,
  editDraft: () => ["app", "edit-draft"] as const,
  newChart: () => ["app", "new-chart"] as const,
  pendingChartSignIn: () => ["app", "pending-chart-sign-in"] as const,
  pendingChartClaim: () => ["app", "pending-chart-claim"] as const,
  adminSession: () => ["app", "admin-session"] as const,
};

export function setWizardQueryState(queryClient: QueryClient, state: WizardQueryState) {
  queryClient.setQueryData(appQueryKeys.wizard(), state);
}

export function clearWizardQueryState(queryClient: QueryClient) {
  queryClient.removeQueries({ queryKey: appQueryKeys.wizard() });
}

export function clearChartFlowQueryState(queryClient: QueryClient) {
  for (const queryKey of [
    appQueryKeys.wizard(),
    appQueryKeys.editDraft(),
    appQueryKeys.newChart(),
    appQueryKeys.pendingChartSignIn(),
    appQueryKeys.pendingChartClaim(),
  ]) {
    queryClient.removeQueries({ queryKey });
  }
}
